import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import * as immutable from 'object-path-immutable'
import { HtmlElement } from "./HtmlElement";
import { emptyObject } from "../../../../redux/utils";
import "./VisualHtmlEditor.css";
import { cleanHtmlJson, toHtmlString } from "./VisualHtmlEditor.helper";

const {html2json, json2html} = require('html2json');
const VisualHtmlEditorContext = createContext(emptyObject);

export const useVisualHtmlEditorContext = () => useContext(VisualHtmlEditorContext);

export const VisualHtmlEditor = ({value, onValueChange, editorStyle}) => {

  const [ jsonObject, setJsonObject ] = useState(emptyObject);

  useEffect(()=>{
    try{
      console.log("VisualHtmlEditor value", value);
      setJsonObject(!!value ? cleanHtmlJson(html2json(value)) : emptyObject);
    }catch(e){
      console.log(e)
    }
  }, []);



  useEffect(()=>{
    //console.log("VisualHtmlEditor", jsonObject);
    console.log("toHtmlString", toHtmlString(jsonObject));
    if(jsonObject && jsonObject !== emptyObject){
      onValueChange(toHtmlString(jsonObject));
    }
  }, [jsonObject])

  const addElement = useCallback((element, path, index) => {
    setJsonObject(value => {
      console.log("addElement", {value, path, element, index})
      return immutable.insert(value, path, element, index)}
    );
  }, [])

  const removeElement = useCallback((path, index) => {
    setJsonObject(value => {
      console.log("removeElement", {path, index})
      return immutable.del(value, path)}
    );
  }, [])

  const changeTagElement = useCallback((tag, path) => {
    setJsonObject(value => {
      console.log("changeTagElement", {tag, path, value})
      return immutable.set(value, `${path}.tag`, tag)}
    );
  }, [])

  const changeAttribName = useCallback((name, newName, path) => {
    setJsonObject(value => {
      console.log("changeAttribName", {name, newName, path, value})
      const attribValue = immutable.get(value, `${path}.attr.${name}`);
      const value2 = immutable.del(value, `${path}.attr.${name}`);
      return immutable.set(value2, `${path}.attr.${newName}`, attribValue);
    });
  }, [])
  
  const changeAttribValue = useCallback((path, name, newValue) => {
    setJsonObject(value => {
      console.log("changeAttribValue", {path, name, newValue, value})
      return immutable.set(value, `${path}.attr.${name}`, newValue);
    });
  }, [])

  return (
    <VisualHtmlEditorContext.Provider value={{addElement, changeTagElement, removeElement, changeAttribName, changeAttribValue}}>
      <div className="vhe-root">
        <HtmlElement element={jsonObject} path=""/>
      </div>
    </VisualHtmlEditorContext.Provider> 
  );
}

export const attributes = {
  key: {type: "string"},
  id: {type: "string"},
  class: {type: "string"},
  title: {type: "string"},
  input_variable: {type: "string"},
  input_context: {type: "string"},
  output_variable: {type: "string"},
  output_context: {type: "string"},
  operations: {type: "string"},
  href: {type: "string"},
  context: {type: "string"},
  target: {type: "string"},
  variable: {type: "string"},
  empty: {type: "string"},
  style: {type: "longString"},
  debug: {type: "booleanString"},
  data: {type: "jsonString"},
  params: {type: "jsonString"},
}

export const basicAttribs = ["key", "id", "class", "style", "title"];


export const tags = {
  div: {attribs: basicAttribs},
  a: {attribs: basicAttribs},
  span: {attribs: basicAttribs},
  style: {acceptElements: false},
  table: {attribs: basicAttribs, acceptElements: ["tbody", "thead", "tr", "th", "caption"]},
  img: {attribs: basicAttribs, acceptElements: false, acceptText: false},
  script: {acceptElements: false, acceptText: false},
  root: {acceptElements: false, acceptText: false},
  lodash: {acceptElements: false, acceptText: false},
  for_each: {acceptElements: false, acceptText: false, attribs: ["variable", "context", "template", "empty", "params"]},
}

